<template>
  <div class="role-flow-add">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">权限申请</h4>
        </Row>
        <!-- <GeneralAlert></GeneralAlert> -->
        <Form inline :label-width="100" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <!-- <Row>
            <Col span="24">
              <FormItem label="标题" style="width: 100%" prop="title">
                <Input :maxlength="100" v-model="baseInfo.title" placeholder="请填写申请标题"/>
              </FormItem>
            </Col>
          </Row> -->
          <!-- <Col span="24">
              <FormItem label="优先级" style="width: 100%" prop="priority">
                <RadioGroup v-model="baseInfo.priority" type="button">
                  <Radio :label="0">普通</Radio>
                  <Radio :label="1">紧急</Radio>
                </RadioGroup>
              </FormItem>
            </Col> -->
         <Row>
            <Col span="24">
              <FormItem label="申请角色" style="width: 100%" prop="role">
                 <RadioGroup v-model="baseInfo.role">
                    <Radio label="开发">开发</Radio>
                    <Radio label="测试">测试</Radio>
                    <Radio label="产品">产品</Radio>
                    <Radio label="项目经理">项目经理</Radio>
                    <Radio label="运维">运维</Radio>
                    <Radio label="客服">客服</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="申请项目" style="width: 100%" prop="module">
                  <Select v-model="baseInfo.module" multiple transfer filterable clearable style="min-width: 350px;" ref="tenantMutipleSelect" class="sel-div">
                    <Option v-for="item in tenantList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
              </FormItem>
            </Col>
          </Row>
          <div style="text-align: center;">
            <Button type="primary" style="margin-right: 10px" :loading="submitting" @click.native="submit">提交申请</Button>
            <Button @click="$router.go(-1)">取消</Button>
          </div>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { createRoleApplicateFlow } from '@/api/workflow/role_applicate_flow'
import { getAllOpsTypes } from '@/api/workflow/ops-flow-type'
import { getModuleAllList } from '@/api/workflow/project'
import GeneralAlert from '../components/general-alert'
import { GetALLUsers, getAllTenants } from '@/api/user'

export default {
  name: 'edit',
  components: {
    GeneralAlert
  },
  data () {
    return {
      tenantList: [],
      pm_visible: false,
      all_user_list: [],
      all_type_list: [],
      editorOptionBody: {
        modules: {
          toolbar: []
        }
      },
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      baseInfo: {
        role: this.$store.state.user.groups.filter(item => ['开发组', '测试组', '产品组', '运维组', '客服组'].indexOf(item.name) > -1).length > 0 ? this.$store.state.user.groups.filter(item => ['开发组', '测试组', '产品组', '运维组', '客服组'].indexOf(item.name) > -1)[0].name.replace('组', '') : '',
        title: '',
        describe: '',
        module: [],
        priority: 0
      },
      version: {},
      baseInfoFormRules: {
        // title: { required: true, message: '标题不能为空', trigger: 'blur' },
        // priority: { required: true, message: '请选择优先级', trigger: 'blur', type: 'number' },
        role: { required: true, message: '请选择角色', type: 'string', trigger: 'change' }
        // describe: { required: true, message: '流程内容不能为空', trigger: 'blur' }
      },
      moduleList: [],
      submitting: false
    }
  },
  mounted: function () {
    // this.getModuleList()
    // this.fetchStepsData()
    // this.getAllUsersData()
    this.getTenants()
  },
  // watch: {
  //   '$store.state.user.defaultTenant' () {
  //     this.fetchStepsData()
  //     // this.getModuleList()
  //   }
  // },
  methods: {
    getTenants () {
      getAllTenants().then(res => {
        let tenants = []
        const result = res.data
        for (let i in result) {
          if (result[i].name.indexOf('运维平台') === -1 && result[i].name.indexOf('公司') === -1) {
            tenants.push({
              id: result[i].id,
              name: result[i].name
            })
          }
        }
        this.tenantList = tenants
      })
    },
    onSelectPm (value) {
      this.fetchStepsData()
    },
    initPm (value) {
      this.baseInfoFormRules.pm[0].required = value
    },
    // 获取所有类型列表
    getAllOpsTypes () {
      this.all_type_list = []
      let params = {
      }
      getAllOpsTypes(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_type_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有用户列表
    getAllUsersData () {
      this.all_user_list = []
      let params = {
        'group_name': '产品组'
      }
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    fetchStepsData () {
      console.log(1111)
      this.baseInfo.steps = []
      let data = {
        type_id: this.baseInfo.type
      }
      getOpsTypeReleaseSteps(data).then(res => {
        if (res.data.data instanceof Array && res.data.data.length > 0) {
          this.baseInfo.steps = res.data.data
          this.baseInfo.steps.map(item => {
            item.users_sel = item.users.map(j => j.username)
          })
          console.log(this.baseInfo.steps)
        }
      })
    },
    // 上传测试报告附件成功
    uploadEnclosureSuccess (res, file) {
      console.log(file)
      if (res) {
        this.baseInfo.enclosure = res
        this.$Notice.success({
          title: '上传成功'
        })
      }
    },
    // 上传测试报告附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传测试报告格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传测试报告超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为10M'
      })
    },
    // 获取模块列表
    getModuleList () {
      this.$refs.releaseModules.clearSingleSelect()
      getModuleAllList({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.moduleList = res.data
      })
    },
    // 提交
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          this.submitting = true
          createRoleApplicateFlow(this.baseInfo).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.$router.push({name: 'roleApplicateFlowDetail', params: { id: res.data.id }})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .role-add-content {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
